exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-container {\n  background-color: #72a7ff;\n  font-size: 1.25rem;\n  padding: 0.75rem;\n  color: #fff;\n  text-align: center; }\n", ""]);

// exports
